export const CapinetInitialState = {
  form: {
    clientType: 'Company',
    cabinetCodes: [],
    searchArea: '',
    areaList: [
      {
        areaId: 0,
        towersCount: 0,
        subsCount: 0,
        fdtList: [],
        attachments: [
          {
            refNo: '',
            refDate: '',
            attachmentType: '',
            attachmentCode: ''
          }
        ]
      }
    ]
  },
  step: 0,
  token: '',
  attachments: {},
  cabinetss: [
    {
      name: 'الشعلة',
      img: 'https://mng-api.supercellnetwork.com/Files/Images/Doraa.jpg',
      cabinets: [
        { name: 'FDT 11', code: 'DR1-11' },
        { name: 'FDT 13', code: 'DR1-13' },
        { name: 'FDT 16', code: 'DR1-16' },
        { name: 'FDT 17', code: 'DR1-17' },
        { name: 'FDT 18', code: 'DR1-18' },
        { name: 'FDT 19', code: 'DR1-19' },
        { name: 'FDT 20', code: 'DR1-20' },
        { name: 'FDT 30', code: 'DR1-30' },
        { name: 'FDT 31', code: 'DR1-31' },
        { name: 'FDT 32', code: 'DR1-32' },
        { name: 'FDT 33', code: 'DR1-33' },
        { name: 'FDT 34', code: 'DR1-34' },
        { name: 'FDT 35', code: 'DR1-35' }
      ]
    }
  ],
  executionTimes: [
    { label: 'شهر', value: 'mounth' },
    { label: 'شهرين', value: 'towMounth' }
  ]
};
